import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { setIsDarkMode } from '../store/slices/themeSlice';
import { useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';


export function useTheme() {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useSelector((state: RootState) => state.theme);

  const initializeTheme = useCallback(async () => {
    if (localStorage.getItem('theme') === 'dark') {
        dispatch(setIsDarkMode(true));
    }
  }, [dispatch]);

  const setIsDarkModeHook = useCallback((isDarkMode: boolean) => {
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    dispatch(setIsDarkMode(isDarkMode));
  }, [dispatch]);

  const isMobile = useMediaQuery({ maxWidth: 767 });

  return {
    isMobile,
    initializeTheme,
    isDarkMode: theme.isDarkMode,
    setIsDarkMode: setIsDarkModeHook
  };
} 